import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { ROTATING_SEGMENT_TITLES } from 'actions/rotatingSegmentTitles';

const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${ROTATING_SEGMENT_TITLES}_LOADING`:
      return state.merge({ loading: true, error: null });
    case ROTATING_SEGMENT_TITLES:
      return state.merge({
        loading: false,
        data: action.payload,
        error: null,
      });
    case `${ROTATING_SEGMENT_TITLES}_ERROR`:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    default:
      return state;
  }
};
